import { Component, computed, input, output, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SoSvgIconUI } from '../so-svg-icon/so-svg-icon.component';
import { SoLoaderUI } from '../so-loader/so-loader.component';


export type SoButtonGradientColor = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'gray' | 'so-gray-thick' | 'primary-secondary' | 'ai';
@Component({
  selector: 'so-button-gradient-ui',
  standalone: true,
  imports: [CommonModule, SoSvgIconUI, SoLoaderUI],
  templateUrl: './so-button-gradient.component.html',
  styleUrl: './so-button-gradient.component.scss',
})
export class SoButtonGradientUI {
  text = input.required<string>();
  icon = input<string>();
  componentIcon = input<{ class: Type<any>, inputs: Record<string, any> }>();
  iconPosition = input<'left' | 'right'>('left');
  variant = input<'gradient' | 'outline' | 'solid'>('gradient');
  shape = input<'pill' | 'square'>('pill');
  color = input<SoButtonGradientColor>('secondary');
  iconColor = input<string | undefined>(undefined);
  disabled = input<boolean>(false);
  loading = input<boolean>(false);
  fontSet = input<'material-icons-outlined' | 'material-icons'>('material-icons');
  height = input<string | number>('auto');

  buttonHeight = computed(() => {
    const h = this.height();
    return typeof h === 'number' ? `${h}px` : h;
  });

  clicked = output<void>();
  
  onClick(): void {
    if (!this.disabled()) {
      this.clicked.emit();
    }
  }
}
